import React from "react";

import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  typography: { padding: 0 },
  root: {
    "& .MuiPaper-root": {
      boxShadow: "0px 0px 8px #00000033;"
    },
    "& .MuiTypography-body1": {
      color: "var(--color-medium-grey)",
      font: "normal normal normal 12px/16px Noto Sans",
      letterSpacing: "0px",
      lineHeight: "33px",
      padding: "0 10px"
    }
  },
  list: {
    padding: 0,
    margin: 0,
    listStyle: "none"
  },
  item: {
    "&:hover": {
      backgroundColor: "var(--color-pale-teal)"
    },
    "&:last-child": {
      border: "none"
    },
    cursor: "pointer",
    display: "flex",
    borderBottom: "0.5px solid var(--color-medium-grey)"
  }
}));

export default function PopoverMenu(props) {
  const classes = useStyles();
  const { menuItems, parentElem, onMenuClose } = props;
  const menuId = props.menuId || "popover-menu-id";
  const [anchorEl, setAnchorEl] = React.useState(null);

  React.useEffect(() => {
    setAnchorEl(parentElem);
  }, [parentElem]);

  const handleClose = () => {
    if (onMenuClose) onMenuClose(null);
    setAnchorEl(null);
  };

  const menuClickHandler = item => {
    if (onMenuClose) onMenuClose(item);
    setAnchorEl(null);
  };

  return (
    <Popover
      classes={{ root: classes.root }}
      id={menuId}
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
    >
      <ul className={classes.list}>
        {menuItems &&
          menuItems.map((item, idx) => (
            <li className={classes.item} key={idx} onClick={() => menuClickHandler(item)}>
              {item.icon && <img src={item.icon} alt={item.label} height="32px" width="32px" />}
              <Typography>{item.label}</Typography>
            </li>
          ))}
      </ul>
    </Popover>
  );
}
